<template>
  <div class="privacy-policy">
    <div v-if="env.isApp" class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
        </template>
      </van-nav-bar>
    </div>
    <div class="page-container">
      <iframe class="iframe" :src="currentDocPath" frameborder="0" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDocPath: null,
      docPathMap: {
        echo: {
          en: '/official_site/echo/privacy-policy.html',
        },
        joychat: {
          en: '/official_site/joychat/privacy-policy.html',
        },
        joyu: {
          en: '/official_site/joyu/privacy-policy.html',
        },
        kiko: {
          en: '/official_site/kiko/privacy-policy.html',
        },
        vava: {
          ar: '/official_site/vava/privacy-policy-ar.html',
          id: '/official_site/vava/privacy-policy-id.html',
          pt: '/official_site/vava/privacy-policy-pt.html',
          en: '/official_site/vava/privacy-policy-en.html',
        },
        vibeo: {
          en: '/official_site/vibeo/privacy-policy.html',
        },
        whonow: {
          en: '/official_site/whonow/privacy-policy.html',
        },
      },
    }
  },
  mounted() {
    if (this.packageName) {
      if (this.docPathMap[this.packageName]) {
        if (this.docPathMap[this.packageName][this.$i18n.locale]) {
          this.currentDocPath = this.docPathMap[this.packageName][this.$i18n.locale]
        }
        //
        else {
          this.currentDocPath = this.docPathMap[this.packageName]['en']
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.privacy-policy {
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  .page-container {
    box-sizing: border-box;
    background-color: #ffffff;
    flex: 1;

    .iframe {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
